import { ArticleFooter } from './ArticleFooter';

export * from './ArticleFooter';

export default ArticleFooter;
